import { ModalityEnum } from '@uplift/types';

export const filterOutGroupModality = <T extends { modality: ModalityEnum }>(modality: T) => {
  return modality.modality !== ModalityEnum.group;
};